import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import RosterIndex from "./RosterIndex";
import { getPreBasePath, getPreBaseRoute } from "../../../../components";
export const getRosterBasePath = () => "/app/roster";
export const rosterCourseSectionPage = (params) => {
    return (getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
        getRosterBasePath() +
        "/courseSection" +
        "?courseSection=" +
        params.courseSectionId);
};
export const courseSectionListPath = (params) => {
    return (getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
        "/controller/courseSection/list");
};
const RosterRoutes = () => (_jsx(Switch, { children: _jsx(Route, { path: getPreBaseRoute() + getRosterBasePath(), component: RosterIndex }) }));
export default RosterRoutes;
